import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { EN_RAFFLE_DEAL_TAB, RaffleDealStoreCtx, TRaffleDealTab } from '@/stores/RaffleDealStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import qs from 'qs';
import React, { useContext, useState } from 'react';

import styles from './RaffleDealTab.module.scss';

const RaffleDealTab: React.FC = () => {
  const [isOpenLoginPopup, setIsOpenLoginPopup] = useState(false);

  const store = useContext(RaffleDealStoreCtx);
  const tabs = Object.keys(EN_RAFFLE_DEAL_TAB) as TRaffleDealTab[];

  const clickTab = (tab: TRaffleDealTab): void => {
    if (!store.isLoggedIn && tab === 'HISTORY') {
      setIsOpenLoginPopup(true);
    } else {
      store.setActiveTab(tab);
    }
  };

  return (
    <>
      <nav className={styles.nav}>
        <ul className={styles.wrap}>
          {tabs.map((tab, idx) => (
            <li
              key={idx}
              className={clsx(styles.tab, store.activeTab === tab && styles.active)}
              onClick={() => clickTab(tab)}
            >
              {tab === 'DRAW' ? store.PromotionTitle : EN_RAFFLE_DEAL_TAB[tab]}
            </li>
          ))}
        </ul>
      </nav>
      <Popup
        isOpen={isOpenLoginPopup}
        mainBtn={{
          label: '로그인하기',
          onClick: () =>
            store.goToLogin(`${window.location.pathname}?${qs.stringify({ tab: 'HISTORY', subTab: 'ALL' })}`),
        }}
        subBtn={{
          label: '닫기',
          onClick: () => setIsOpenLoginPopup(false),
        }}
      >
        {{ title: '로그인이 필요합니다.' }}
      </Popup>
    </>
  );
};

export default observer(RaffleDealTab);
